import { StringHelper } from '../../../core/helpers/strings.helper';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { BaseFormComponent } from '../base-form/base-form.component';
import { CustomFormControl, CustomFormControlDefinition } from '../../../shared/utils/custom-form-control';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ScreenCaptureService } from '../../../core/services/screen-capture.service';
import { Component, OnInit, Output, EventEmitter, Input, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { UpdateOutletAgentLivelinessRequest } from '../../../shared/models/profile.model';
import { KycService } from '../../../core/services/kyc-service';
import { ModalHelperService, ModalOptions } from '../../../core/services/modal-helper.service';
import { ModalOptionsConfig, ModalService } from '../nz-modal-service/modal.service';
import {
	DEFAULT_DIALOG_CLASSES,
	DEFAULT_MODAL_KAMONA_CLASSES,
	DEFAULT_MODAL_WIDTH,
	MONIEPOINT_DESIGN_TYPE
} from '../../../shared/constants';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { MobileDelegateService } from '../../../core/services/mobile-delegate.service';
import { MobileWebViewService } from '../../../core/services/mobile-web-view.service';
import { DialogMessageType } from '../../../shared/models/utility.model';
import { PlainResultModalComponent } from '../../../shared/components/plain-result-modal/plain-result-modal.component';
import { CustomMetaMapButtonComponent } from '../../../kamona/components/custom-meta-map-button/custom-meta-map-button.component';


@Component({
	selector: 'app-liveliness-webcam',
	templateUrl: './liveliness-webcam.component.html',
	styleUrls: ['./liveliness-webcam.component.scss']
})
export class LivelinessWebcamComponent extends BaseFormComponent implements OnInit, AfterViewInit, OnDestroy {

	@Output() cancel: EventEmitter<any> = new EventEmitter();
	@Output() proceed: EventEmitter<any> = new EventEmitter();
	@Input() validateUsingMetaMap: boolean;
	@Input() usePin: boolean;
	@Input() isLoanLiveliness: boolean;
	@Input() loading: boolean;
	@Input() errorMessage;
	@Input() isMobile: boolean;
	@ViewChild('metamap_button') metaMapBtn: CustomMetaMapButtonComponent;

	showCamera: boolean;

	showWebcam = true;
	allowCameraSwitch = true;
	multipleWebcamsAvailable = false;
	deviceId: string;
	videoOptions: MediaTrackConstraints = {
		// width: {ideal: 1024},
		// height: {ideal: 576}
	};
	errors: WebcamInitError[] = [];

	// latest snapshot
	webcamImage: WebcamImage = null;

	// webcam snapshot trigger
	private trigger: Subject<void> = new Subject<void>();
	// switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
	private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
	snapShots: WebcamImage[] = [];
	filesArr: any[] = [];
	pin: CustomFormControlDefinition;
	form: FormGroup;
	metaMapReference: string;
	errorTitle: string;
	suspensionReleaseTime: any;
	runningModal: NzModalRef;
	readonly LIVELINESS = 'liveliness';
	isMobileWebViewUser: boolean;
	counter = 2;
	timeoutId: any;
	intervalTime = 1000;
	numberOfRetry = 0;
	maximumNoOfRetry = 6;
	cancelled = false;

	constructor(
		private captureService: ScreenCaptureService,
		private auth: AuthenticationService,
		public fb: FormBuilder,
		private kycService: KycService,
		private modalHelper: ModalHelperService,
		private modalService: ModalService,
		public mobileService: MobileWebViewService,
		public delegateService: MobileDelegateService,
	) {
		super(fb);
		this.pin = new CustomFormControl()
			.id('pin')
			.placeholder('Enter PIN')
			.name('pin')
			.isRequired()
			.type('password')
			.maxLength(4)
			.minLength(4)
			.build();

		this.form = fb.group({
			pin: this.pin.formGroupControl
		});
		
	}

	ngOnInit(): void {
		if (this.validateUsingMetaMap) {
			this.getMetaMapReference();
		}
		this.isMobileWebViewUser = this.mobileService.isMobileWebViewUser();
		this.showCamera = this.isLoanLiveliness ? true : !this.usePin;
		WebcamUtil.getAvailableVideoInputs()
			.then((mediaDevices: MediaDeviceInfo[]) => {
				this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
			});
	}

	ngAfterViewInit(): void {
		/* if (this.validateUsingMetaMap) {
			this.initializingMetaMap();
		} */
	}

	/* initializingMetaMap() {
		const metaMapBtn = document.getElementById('mati_button');
		metaMapBtn?.addEventListener('click', this.onMetaMapClick);
		metaMapBtn?.addEventListener('mati:loaded', this.onMetaMapLoaded);
		metaMapBtn?.addEventListener('mati:userFinishedSdk', this.onMetaMapFinished);
		metaMapBtn?.addEventListener('mati:exitedSdk', this.onMetaMapExited);
	} */

	onMetaMapClick = () => {
		this.metaMapBtn?.submit();
		this.submittingForm = true;
	}

	onMetaMapLoaded = () => {
		this.submittingForm = false;
	}

	onMetaMapFinished = () => {
		this.getMetaMapStatus(this.kycService.getSaveMetaMapPersonalInfoReference());
		this.timeoutId = setTimeout(() => {
			this.incrementCounter();
		}, this.intervalTime);
	}

	onMetaMapExited = () => {
		const modalOptions: ModalOptions = {
			title: 'Verification Failed',
			description: 'Meta map verification was not completed.' +
				' Please try again',
			alertType: 'warning',
			callbackName: 'Retry Verification',
		};
		this.modalHelper.alert(modalOptions);
		this.kycService.clearMetaReferenceData();
		//this.getMetaMapReference();
	}

	getPersonalInfoFlowId() {
		return this.kycService.getPersonalInfoFlowId();
	}

	getMetaMapStatus(reference: string) {
		if (this.cancelled) {
			this.submittingForm = false;
			return;
		}
		this.submittingForm = true;
		this.kycService.getMetaMapPersonalInfoReferenceStatus(reference)
			.then(res => {
				if (res?.verified) {
					this.submittingForm = false;
					this.cancelEvent();
					this.kycService.clearMetaReferenceData();
				}
				if (!res?.verified) {
					if (this.numberOfRetry >= this.maximumNoOfRetry - 1) {
						const params = {
							title: 'Verification Failed',
							description: 'Meta map verification was not completed.' +
								' Please try again',
							alertType: 'warning',
							callbackName: 'Retry Verification',
						}
						if (this.isMobile) {
							this.launchFullAlertModal(params);
						} else {
							this.launchAlertModal(params);
						}
						this.kycService.clearMetaReferenceData();
						this.submittingForm = false;
						//this.getMetaMapReference()
					}

				} else {
					this.submit();
				}
			}).catch(error => {
				this.errorMessage = error?.error?.responseMessage || StringHelper.getErrorMessageHttpErrorResponse(error);
				if (this.isMobile) {
					this.launchFullAlertModal({
						title: this.errorTitle,
						description: this.errorMessage,
						callbackName: 'Continue'
					});
				} else {
					this.launchAlertModal({
						title: this.errorTitle,
						description: this.errorMessage,
						callbackName: 'Continue'
					});
				}
				this.submittingForm = false;
			});

	}

	getMetaMapReference() {
		this.submittingForm = true;
		this.kycService.getMetaMapPersonalInfoReference()
			.then(res => {
				this.submittingForm = false;
				this.setMapMapReference(res.reference);
				this.setMetaMapButtonAttribute();
				this.kycService.saveMetaMapPersonalInfoReference(`${res.reference}`);
				//this.onMetaMapClick();
			}).catch(error => {
				this.errorMessage = error?.error?.responseMessage || StringHelper.getErrorMessageHttpErrorResponse(error);
				if (this.isMobile) {
					this.launchFullAlertModal({
						title: this.errorTitle,
						description: this.errorMessage,
						callbackName: 'Continue'
					});
				} else {
					this.launchAlertModal({
						title: this.errorTitle,
						description: this.errorMessage,
						callbackName: 'Continue'
					});
				}
				this.submittingForm = false;
			});
	}

	getMobileMetaMapMetaData(reference) {
		return { reference, verificationType: this.LIVELINESS };
	}

	createModalConfig(data?) {
		const config = new ModalOptionsConfig();
		if (data) {
			config.nzComponentParams.data = data;
		}
		config.nzComponentParams.callback = (result) => {
			this.errorMessage = '';
			this.runningModal.destroy();
		};
		return config;
	}

	successRequestHandler(ref) {
		const data = {
			isMobile: this.isMobile,
			modalBody: this.errorMessage,
			messageType: DialogMessageType.SUCCESS,
			modalTitle: `Verified Liveliness`,
		};
		const config = this.createModalConfig(data);
		config.nzComponentParams.callback = () => {
			this.runningModal.destroy();
		};
		this.runningModal = this.modalService.createModal(PlainResultModalComponent, config);
	}

	launchAlertModal(params) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.alertType = 'error';
		config.nzComponentParams.title = params?.title;
		config.className = DEFAULT_MODAL_KAMONA_CLASSES;
		config.nzWidth = DEFAULT_MODAL_WIDTH;
		config.nzComponentParams.callback = () => {
			this.handleCloseModal();
		};
		config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
		config.nzComponentParams.callbackName = params?.callbackName || 'Close';
		config.nzComponentParams.message = params?.description;
		this.runningModal = this.modalService.alert(config);
		this.kycService.clearMetaReferenceData();
	}

	launchFullAlertModal(params) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.alertType = params?.alertType || 'error';
		config.nzComponentParams.title = params?.title || 'Validation Error';
		config.className = DEFAULT_DIALOG_CLASSES;
		// config.nzWidth = DEFAULT_MODAL_WIDTH;
		config.nzComponentParams.callback = () => {
			this.handleCloseModal();
		};
		config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
		config.nzComponentParams.expiryTime = params?.expiryTime;
		config.nzComponentParams.callbackName = params?.callbackName || 'Close';
		config.nzComponentParams.message = params?.description;
		this.runningModal = this.modalService.newalert(config);
		this.kycService.clearMetaReferenceData();
	}

	handleCloseModal() {
		this.runningModal?.destroy();
		this.kycService.clearMetaReferenceData();
	}

	setMapMapReference(ref) {
		this.metaMapReference = `{"reference": "${ref}"}`;
	}

	setMetaMapButtonAttribute() {
		/* const metaMapBtn = document.getElementById('mati_button');
		metaMapBtn.setAttribute('flowId', this.getPersonalInfoFlowId());
		metaMapBtn.setAttribute('metadata', this.metaMapReference); */
	}

	validatePin() {
		if (!this.validateForm() || this.submittingForm) {
			return;
		}
		this.submittingForm = true;
		const param = this.form.value;
		this.auth.validatePin(param).then(res => {
			if (!this.validateUsingMetaMap) {
				this.showCamera = true;
				this.submit()
			} else {
				//this.getMetaMapReference();
				this.onMetaMapClick();
			}
			this.submittingForm = false;
		}).catch(err => {
			this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(err);
			this.submittingForm = false;
		});
	}

	submit() {
		const obj: { files, pin?} = { files: this.filesArr };
		if (this.usePin) {
			obj.pin = this.form.value.pin;
		}
		this.proceed.emit(obj);
		this.kycService.clearMetaReferenceData();
	}

	submitLoanLiveliness() {
		this.submittingForm = true;
		const param = new UpdateOutletAgentLivelinessRequest();
		param.pin = this.form.value.pin;
		param.imageOne = this.filesArr[0];
		param.imageTwo = this.filesArr[1];
		this.submitLivelinessCheck(param);
	}

	submitLivelinessCheck(param) {
		this.auth.postLivelinessCheck(param)
			.then(_data => {
				this.errorMessage = null;
				this.proceed.emit(true);
				this.submittingForm = false;
			})
			.catch(error => {
				this.errorMessage =
					StringHelper.getErrorMessageHttpErrorResponse(error);
				this.submittingForm = false;
			});
	}

	removePhoto(photo: WebcamImage) {
		const index = this.snapShots.findIndex(x => photo.imageAsDataUrl === x.imageAsDataUrl);
		this.snapShots.splice(index, 1);
	}

	triggerSnapshot(): void {
		this.trigger.next();
	}

	clearShots() {
		this.snapShots = [];
	}

	toggleWebcam(): void {
		this.showWebcam = !this.showWebcam;
	}

	handleInitError(error: WebcamInitError): void {
		this.errors.push(error);
	}

	showNextWebcam(directionOrDeviceId: boolean | string): void {
		// true => move forward through devices
		// false => move backwards through devices
		// string => move to device with given deviceId
		this.nextWebcam.next(directionOrDeviceId);
	}

	handleImage(webcamImage: WebcamImage): void {
		this.webcamImage = webcamImage;
		const image = webcamImage;
		const imgFile = this.captureService.base64ToFile(webcamImage.imageAsDataUrl, 'image.jpg');
		this.snapShots.push(image);
		this.filesArr.push(imgFile);
	}

	cameraWasSwitched(deviceId: string): void {
		this.deviceId = deviceId;
	}

	get triggerObservable(): Observable<void> {
		return this.trigger.asObservable();
	}

	get nextWebcamObservable(): Observable<boolean | string> {
		return this.nextWebcam.asObservable();
	}

	validateLivelinessForm() {
		return this.form.valid && this.snapShots.length === 2;
	}

	incrementCounter() {
		this.counter = this.counter * 2;
		this.numberOfRetry++;
		if (this.numberOfRetry >= this.maximumNoOfRetry) {
			this.cancelEvent();
			return;
		}
		this.intervalTime = this.counter * 1000;
		clearTimeout(this.timeoutId);
		this.timeoutId = setTimeout(() => {
			this.incrementCounter();
			this.getMetaMapStatus(this.kycService.getSaveMetaMapPersonalInfoReference());
		}, this.intervalTime);
	}


	cancelEvent() {
		clearTimeout(this.timeoutId);
		this.submittingForm = false;
		this.cancelled = true;
		this.numberOfRetry = 0;
		this.counter = 2;
		this.intervalTime = 1000;
	}

	ngOnDestroy(): void {
	}

}
